export enum BookingApprovalStatus {
    Open = 0,
    Approved = 1,
    Declined = 2,
    Withdrawn = 3,
    Canceled = 4
  }
  